<template>
  <div class="my-import-file-popup">
    <el-button type="primary" @click="open">
      本地导入<i class="el-icon-upload"></i>
    </el-button>

    <MyDialog
      title="行业场景本地导入"
      :isOpen.sync="isVisible"
      @callback="close"
      width="40%"
    >
      <template v-slot:body>
        <div v-if="isVisible" v-loading="loading">
          <div>
            <el-alert type="info" show-icon :closable="false">
              <div slot="title" class="file-template">
                <p v-if="isShowTemplate">
                  请按指定模板上传，<span
                    class="download"
                    @click="downloadTemplate"
                    >点击下载模板</span
                  >。
                </p>
                <p v-else>
                  <span v-if="listType === 'list'">当前仅支持pdf文件。</span>
                </p>
              </div>
            </el-alert>
           
            <SingleUpload  ref="uploadRef" />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <el-button
            type="primary"
            @click="onReadySubmit"
            :loading="submitLoading"
          >
            确 定
          </el-button>
          <el-button @click="close()">取 消</el-button>
        </div>
      </template>
    </MyDialog>
  </div>
</template>
<script>
//components
import MyDialog from "@/components/MyDialog/index.vue";
import SingleUpload from "./components/SingleUpload.vue";
import InputUpload from "./components/InputUpload.vue";
import MutliUpload from "./components/MutliUpload.vue";
//api
import { downloadTemplate } from "@/api/common.js"; //文件上传模板
import { industryLoaclUploadaApi } from "@/api/technology.js"; //行业数据本地导入
// utils
import { saveAs } from "file-saver";
import { downFile } from "@/utils/tool";
import {
  templateTypes,
  API,
  importFileInterfaceMap,
  tianyanAPI,
  importTianyanMap
} from "./data.js";

export default {
  name: "MyImportFilePopup",
  components: {
    MyDialog,
    SingleUpload,
    MutliUpload,
    InputUpload
  },
  props: {
    // 导入按钮名称
    moduleOriginCnName: {
      type: String,
      default: "企业数据"
    },
    // 是否显示输入关键字导入
    isShowInputUpload: {
      type: Boolean,
      default: true
    },
    // 用于控制是否显示本地导入
    isShowLocalUpload: {
      type: Boolean,
      default: true
    },
    //用于企业数据的天眼查导入
    isShowCompanyTianyanUpload: {
      type: Boolean,
      default: false
    },
    //上传多个的类型
    listType: {
      type: String,
      default: "" // "list"-为列表上传 例如研究报告的多个pdf;"list-input"-为列表输入上传 例如多个链接上传
    }
  },
  computed: {
    //查询当前类型是否有模板
    isShowTemplate() {
      return true;
    },
    Authorization() {
      return sessionStorage.getItem("token");
    }
  },
  data() {
    return {
      currentCommand: 1, // 1:天眼查导入 2:本地导入
      submitLoading: false, //确认按钮loading
      loading: false,
      isVisible: false,
      dialogTitle: ""
    };
  },
  methods: {
    //开启弹窗
    open() {
      this.isVisible = true;
    },
    // 关闭弹窗
    close() {
      this.isVisible = false;
    },
    // 点击下拉菜单
    onCommand(command) {
      this.isVisible = true;
      this.currentCommand = Number(command);
      this.dialogTitle = `${this.moduleOriginCnName}${
        this.currentCommand === 2 ? "（本地导入）" : "（天眼查导入）"
      }`;
    },
    // 点击提交按钮前的准备
    onReadySubmit() {
        const form = this.$refs.uploadRef.currentFile;

       this.handleSingleFileUplaod(form);
    },

    //点击单个文件导入
    async handleSingleFileUplaod(file) {
    
      const fileParmsName = 'file'
      const formData = new FormData();
      formData.append(fileParmsName, file);
      formData.append("Authorization", this.Authorization);
     

      this.$modal.loading("文件上传中，请稍候...");
      this.submitLoading = true;

      //调用接口上传接口 获取响应 状态处理
      await industryLoaclUploadaApi(formData)

        .then(res => {
          if (res) {
            this.submitLoading = false;
            this.$modal.closeLoading();
            const isFail = !_.includes([200, 415], res.code);
            const msg = isFail ? "文件上传失败！" : "文件上传成功！";
            this.$alert(res.msg ? res.msg : msg, "提示", {
              dangerouslyUseHTMLString: true
            })
              .then(() => {
                this.$emit("on-success");
                this.$emit("close");
              })
              .catch(() => {});
          }
        })
        .catch(err => {
          if (err) {
            this.submitLoading = false;
            this.$modal.closeLoading();
          }
        });
    },
    //天眼查本地导入
    async handleCompanyTianyanUpload(files) {
      //参数准备
      const typs = ["行业知识", "论文数据"];
      const fileParmsName = _.includes(typs, this.moduleOriginCnName)
        ? "files"
        : "file";
      const formData = new FormData();
      formData.append(fileParmsName, files[0].raw);
      formData.append("Authorization", this.Authorization);
      //接口准备-根据模块名称获取接口名称
      const interfaceName = importTianyanMap[this.moduleOriginCnName];
      const interfaceFn = tianyanAPI[interfaceName];

      this.$modal.loading("文件上传中，请稍候...");
      this.submitLoading = true;

      //调用接口上传接口 获取响应 状态处理
      await interfaceFn(formData)
        .then(res => {
          if (res) {
            this.submitLoading = false;
            this.$modal.closeLoading();
            const isFail = !_.includes([200, 415], res.code);
            const msg = isFail ? "文件上传失败！" : "文件上传成功！";
            this.$alert(res.msg ? res.msg : msg, "提示", {
              dangerouslyUseHTMLString: true
            })
              .then(() => {
                this.$emit("on-success");
                this.$emit("close");
              })
              .catch(() => {});
          }
        })
        .catch(err => {
          if (err) {
            this.submitLoading = false;
            this.$modal.closeLoading();
          }
        });
    },
    //下载文件模板
    async downloadTemplate() {
      this.$modal.loading("正在获取模版，请稍候...");
      const href =
        "https://elitego-data-dev-1300257084.cos.ap-shanghai.myqcloud.com/elite-all/317ac6b0ea71432da9fc9c717e8e7c94场景知识导入模板.xlsx";
      const a = document.createElement("a"); //创建a标签
      a.style.display = "none";
      a.href = href; // 指定下载'链接
      a.download = "场景知识导入模板.xlsx";
      a.click(); //触发下载
      window.URL.revokeObjectURL(a.href); //释放URL对象
      if (document.body.contains(a)) {
        document.body.removeChild(a); //释放标签
      }
      this.$modal.closeLoading();
    }
  }
};
</script>
<style lang="less" scoped>
::v-deep .file-template {
  text-align: center;
  user-select: none;
  .download {
    color: #409eff;
    cursor: pointer;
  }
}
</style>
